var _path, _path2, _path3, _path4, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.59262 12.2966C9.59262 12.0157 9.82033 11.788 10.1012 11.788H13.492C13.7729 11.788 14.0006 12.0157 14.0006 12.2966C14.0006 12.5775 13.7729 12.8052 13.492 12.8052H10.1012C9.82033 12.8052 9.59262 12.5775 9.59262 12.2966Z",
    fill: "#3BC996"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7966 10.0926C12.0775 10.0926 12.3052 10.3203 12.3052 10.6012V12.2966V13.9919C12.3052 14.2728 12.0775 14.5005 11.7966 14.5005C11.5157 14.5005 11.288 14.2728 11.288 13.9919V10.6012C11.288 10.3203 11.5157 10.0926 11.7966 10.0926Z",
    fill: "#3BC996"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.661 6.22715C8.38383 6.22715 5.72718 8.8838 5.72718 12.1609C5.72718 15.4381 8.38383 18.0947 11.661 18.0947C14.9381 18.0947 17.5947 15.4381 17.5947 12.1609C17.5947 8.8838 14.9381 6.22715 11.661 6.22715ZM4.70996 12.1609C4.70996 8.322 7.82203 5.20993 11.661 5.20993C15.4999 5.20993 18.612 8.322 18.612 12.1609C18.612 15.9999 15.4999 19.1119 11.661 19.1119C7.82203 19.1119 4.70996 15.9999 4.70996 12.1609Z",
    fill: "#3BC996"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0656 17.5655C17.2642 17.3669 17.5862 17.3669 17.7849 17.5655L19.1411 18.9218C19.3398 19.1205 19.3398 19.4425 19.1411 19.6411C18.9425 19.8397 18.6205 19.8397 18.4219 19.6411L17.0656 18.2848C16.8669 18.0862 16.8669 17.7642 17.0656 17.5655Z",
    fill: "#3BC996"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 23,
    height: 23,
    rx: 4.5,
    stroke: "#3BC996"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoomIn.8dcbb73c264a8a145c93082053df8916.svg";
export { ForwardRef as ReactComponent };